// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as ScrollLock$Showside from "../utils/ScrollLock.bs.js";
import * as IframeEmbed$Showside from "../utils/IframeEmbed.bs.js";
import * as Prioritize2$Showside from "../utils/Prioritize2.bs.js";
import * as Slider_Lazy$Showside from "../utils/Slider_Lazy.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as SmartNavVideo$Showside from "./SmartNavVideo.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as DesktopPhotoZoom$Showside from "./DesktopPhotoZoom.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as PhotoSliderThumbnails$Showside from "./PhotoSliderThumbnails.bs.js";
function DesktopPhotoSlider$BlurBg(Props) {
  var medias = Props.medias;
  var src = Belt_Option.flatMap(Belt_Array.get(medias, 0), Product$Showside.Media.getImageUrlWithPosterFallback);
  var tmp = {};
  if (src !== undefined) {
    tmp.src = Caml_option.valFromOption(src);
  }
  return React.createElement(SmartImg$Showside.ColorOverlay.make, tmp);
}
DesktopPhotoSlider$BlurBg.displayName = "DesktopPhotoSlider.BlurBg";
var BlurBg = {
  make: DesktopPhotoSlider$BlurBg
};
function DesktopPhotoSlider$SliderItem(Props) {
  var idxOpt = Props.idx;
  var enterZoom = Props.enterZoom;
  var renderChildren = Props.renderChildren;
  var zoomRequireOpt = Props.zoomRequire;
  var idx = idxOpt !== undefined ? idxOpt : 0;
  var zoomRequire = zoomRequireOpt !== undefined ? zoomRequireOpt : true;
  var parentRef = React.useRef(null);
  var baseClassName = CSS$Showside.prefix(Cn.make(["flex items-center justify-center h-full w-full overflow-hidden relative transition-opacity duration-300"]));
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(parentRef),
    className: baseClassName
  }, React.createElement(ScrollLock$Showside.make, {
    children: React.createElement(Prioritize2$Showside.make, {
      render: function (priority) {
        return React.createElement(DataAttribute$Showside.make, {
          dataTestId: "pdp-photo",
          children: React.createElement("div", {
            className: CSS$Showside.prefix(Cn.make([zoomRequire ? "cursor-zoom-in" : "cursor-default", "absolute inset-0"])),
            onClick: function (param) {
              if (zoomRequire) {
                return Curry._1(enterZoom, idx);
              }
            }
          }, Curry._1(renderChildren, priority))
        });
      }
    })
  }));
}
DesktopPhotoSlider$SliderItem.displayName = "DesktopPhotoSlider.SliderItem";
var SliderItem = {
  make: DesktopPhotoSlider$SliderItem
};
function DesktopPhotoSlider(Props) {
  var product = Props.product;
  var variantId = Props.variantId;
  var medias = Props.medias;
  var viewport = Props.viewport;
  var onPhotoZoomed = Props.onPhotoZoomed;
  var onSlideChange = Props.onSlideChange;
  var onClickThumbnail = Props.onClickThumbnail;
  var zoomOpt = Props.zoom;
  var bgBlurOpt = Props.bgBlur;
  var thumbnailsPositionOpt = Props.thumbnailsPosition;
  var selectedIndex = Props.selectedIndex;
  var zoomRequireOpt = Props.zoomRequire;
  var zoom = zoomOpt !== undefined ? zoomOpt : true;
  var bgBlur = bgBlurOpt !== undefined ? bgBlurOpt : true;
  var thumbnailsPosition = thumbnailsPositionOpt !== undefined ? thumbnailsPositionOpt : "bottom";
  var zoomRequire = zoomRequireOpt !== undefined ? zoomRequireOpt : true;
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  var match$1 = ViewportContext$Showside.use(undefined);
  var match$2 = React.useState(function () {
    return 0;
  });
  var setCurrentSlide = match$2[1];
  var currentSlide = match$2[0];
  var match$3 = React.useState(function () {
    return Belt_Option.getWithDefault(selectedIndex, -1);
  });
  var setSlideToIndex = match$3[1];
  var match$4 = RouterProvider$Showside.useRouter(undefined);
  var route = match$4.route;
  React.useEffect(function () {
    Curry._1(setSlideToIndex, function (param) {
      return Belt_Option.getWithDefault(selectedIndex, -1);
    });
  }, [selectedIndex]);
  var items = Belt_Array.mapWithIndex(medias, function (idx, item) {
    var active = Caml_obj.equal(idx, currentSlide);
    switch (item.TAG | 0) {
      case /* Image */0:
        var url = item._0.url;
        return React.createElement(DesktopPhotoSlider$SliderItem, {
          idx: idx,
          enterZoom: function (i) {
            Curry._1(onPhotoZoomed, i);
          },
          viewport: viewport,
          active: active,
          renderChildren: function (priority) {
            return React.createElement(SmartImg$Showside.make, {
              src: url,
              fit: /* ScaleDown */0,
              priority: active ? 0 : priority
            });
          },
          zoomRequire: zoomRequire,
          key: variantId
        });
      case /* Video */1:
        var video = item._0;
        var src = Belt_Option.map(Product$Showside.getVideoSource(video), function (source) {
          return source.url;
        });
        if (src !== undefined) {
          return React.createElement(DesktopPhotoSlider$SliderItem, {
            idx: idx,
            enterZoom: function (i) {
              Curry._1(onPhotoZoomed, i);
            },
            viewport: viewport,
            active: active,
            renderChildren: function (param) {
              var tmp = {
                src: src,
                viewport: viewport,
                objectFit: "contain",
                prioritize: true,
                autoplay: settings.videoAutoPlay,
                loop: settings.videoLoop,
                muted: settings.videoMute,
                controls: settings.videoControls,
                key: variantId
              };
              if (video.posterUrl !== undefined) {
                tmp.poster = video.posterUrl;
              }
              return React.createElement(SmartNavVideo$Showside.make, tmp);
            },
            zoomRequire: zoomRequire,
            key: variantId
          });
        } else {
          return null;
        }
      case /* IframeEmbed */2:
        var url$1 = item._0.url;
        return React.createElement(DesktopPhotoSlider$SliderItem, {
          idx: idx,
          enterZoom: function (i) {
            Curry._1(onPhotoZoomed, i);
          },
          viewport: viewport,
          active: active,
          renderChildren: function (param) {
            return React.createElement(IframeEmbed$Showside.make, {
              url: url$1
            });
          },
          zoomRequire: zoomRequire,
          key: variantId
        });
    }
  });
  var onSlideChange$1 = function (e) {
    Curry._1(setCurrentSlide, function (param) {
      return e.activeIndex;
    });
    Curry._1(setSlideToIndex, function (param) {
      return -1;
    });
    Curry._1(onSlideChange, undefined);
  };
  var match$5 = settings.pdpGalleryCustomAction;
  var tmp = {
    medias: medias,
    setSlideToIndex: setSlideToIndex,
    onClickThumbnail: onClickThumbnail,
    visibility: match$5 !== undefined ? "always" : "hover",
    product: product,
    variantId: variantId
  };
  if (currentSlide !== undefined) {
    tmp.currentSlide = Caml_option.valFromOption(currentSlide);
  }
  var tmp$1;
  if (zoom && !(typeof route === "number" || route.TAG !== /* PDP */2)) {
    var zoomedPhotoIndex = route._0.zoomedPhotoIndex;
    if (Belt_Option.isSome(zoomedPhotoIndex)) {
      var tmp$2 = {
        product: product,
        variantId: variantId,
        medias: medias,
        viewport: viewport,
        onSlideChange: onSlideChange$1,
        onClickThumbnail: onClickThumbnail,
        bgBlur: false,
        thumbnailsPosition: "center",
        onClose: function (param) {
          Curry._1(onPhotoZoomed, undefined);
        },
        onPhotoZoomed: onPhotoZoomed
      };
      if (zoomedPhotoIndex !== undefined) {
        tmp$2.selectedIndex = Caml_option.valFromOption(zoomedPhotoIndex);
      }
      tmp$1 = React.createElement(DesktopPhotoZoom$Showside.make, tmp$2);
    } else {
      tmp$1 = null;
    }
  } else {
    tmp$1 = null;
  }
  var content = React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0 overflow-hidden group"),
    style: {
      backgroundColor: settings.pdpGalleryBGColor
    }
  }, React.createElement(ConditionalRender$Showside.When.make, {
    condition: bgBlur && settings.pdpGalleryBGBlur,
    children: React.createElement(DesktopPhotoSlider$BlurBg, {
      medias: medias,
      needsBorderRadius: settings.smartbarEnabled && !match$1.isMobile
    })
  }), React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0")
  }, React.createElement(Slider_Lazy$Showside.make, {
    items: items,
    spaceBetween: 12,
    slidesPerView: /* Float */{
      _0: 1.1
    },
    direction: "vertical",
    enableFreeMode: true,
    centeredSlides: true,
    autoHeight: true,
    slideToIndex: match$3[0],
    allowTouchMove: medias.length > 1,
    enableScrollbar: medias.length > 1,
    hideScrollbar: true,
    enableMousewheel: true,
    className: CSS$Showside.prefix("absolute inset-0"),
    onSlideChange: onSlideChange$1,
    restorationId: "pdp-photo-slider",
    key: variantId
  })), React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute", thumbnailsPosition === "center" ? "top-1/2 left-0 pl-8" : "bottom-0 right-0 pb-8 pr-8"]))
  }, React.createElement(PhotoSliderThumbnails$Showside.make, tmp)), tmp$1);
  return React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0 overflow-hidden")
  }, content);
}
DesktopPhotoSlider.displayName = "DesktopPhotoSlider";
var make = DesktopPhotoSlider;
export { BlurBg, SliderItem, make };
/* react Not a pure module */